export default "__VITE_ASSET__40de743e__"